export default __webpack_public_path__ + "static/23_36-4cdf447f7f295f5e9037859a8c7d69e6.png";